var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"pa-0 pb-5 elevation-0"},[_c('canvas',{ref:"chart3",attrs:{"id":"chart3","height":"500"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }